import _ad from 'flag-icons/flags/4x3/ad.svg';
import _ae from 'flag-icons/flags/4x3/ae.svg';
import _af from 'flag-icons/flags/4x3/af.svg';
import _ag from 'flag-icons/flags/4x3/ag.svg';
import _ai from 'flag-icons/flags/4x3/ai.svg';
import _al from 'flag-icons/flags/4x3/al.svg';
import _am from 'flag-icons/flags/4x3/am.svg';
import _ao from 'flag-icons/flags/4x3/ao.svg';
import _aq from 'flag-icons/flags/4x3/aq.svg';
import _ar from 'flag-icons/flags/4x3/ar.svg';
import _as from 'flag-icons/flags/4x3/as.svg';
import _at from 'flag-icons/flags/4x3/at.svg';
import _au from 'flag-icons/flags/4x3/au.svg';
import _aw from 'flag-icons/flags/4x3/aw.svg';
import _ax from 'flag-icons/flags/4x3/ax.svg';
import _az from 'flag-icons/flags/4x3/az.svg';
import _ba from 'flag-icons/flags/4x3/ba.svg';
import _bb from 'flag-icons/flags/4x3/bb.svg';
import _bd from 'flag-icons/flags/4x3/bd.svg';
import _be from 'flag-icons/flags/4x3/be.svg';
import _bf from 'flag-icons/flags/4x3/bf.svg';
import _bg from 'flag-icons/flags/4x3/bg.svg';
import _bh from 'flag-icons/flags/4x3/bh.svg';
import _bi from 'flag-icons/flags/4x3/bi.svg';
import _bj from 'flag-icons/flags/4x3/bj.svg';
import _bl from 'flag-icons/flags/4x3/bl.svg';
import _bm from 'flag-icons/flags/4x3/bm.svg';
import _bn from 'flag-icons/flags/4x3/bn.svg';
import _bo from 'flag-icons/flags/4x3/bo.svg';
import _bq from 'flag-icons/flags/4x3/bq.svg';
import _br from 'flag-icons/flags/4x3/br.svg';
import _bs from 'flag-icons/flags/4x3/bs.svg';
import _bt from 'flag-icons/flags/4x3/bt.svg';
import _bv from 'flag-icons/flags/4x3/bv.svg';
import _bw from 'flag-icons/flags/4x3/bw.svg';
import _by from 'flag-icons/flags/4x3/by.svg';
import _bz from 'flag-icons/flags/4x3/bz.svg';
import _ca from 'flag-icons/flags/4x3/ca.svg';
import _cc from 'flag-icons/flags/4x3/cc.svg';
import _cd from 'flag-icons/flags/4x3/cd.svg';
import _cf from 'flag-icons/flags/4x3/cf.svg';
import _cg from 'flag-icons/flags/4x3/cg.svg';
import _ch from 'flag-icons/flags/4x3/ch.svg';
import _ci from 'flag-icons/flags/4x3/ci.svg';
import _ck from 'flag-icons/flags/4x3/ck.svg';
import _cl from 'flag-icons/flags/4x3/cl.svg';
import _cm from 'flag-icons/flags/4x3/cm.svg';
import _cn from 'flag-icons/flags/4x3/cn.svg';
import _co from 'flag-icons/flags/4x3/co.svg';
import _cr from 'flag-icons/flags/4x3/cr.svg';
import _cu from 'flag-icons/flags/4x3/cu.svg';
import _cv from 'flag-icons/flags/4x3/cv.svg';
import _cw from 'flag-icons/flags/4x3/cw.svg';
import _cx from 'flag-icons/flags/4x3/cx.svg';
import _cy from 'flag-icons/flags/4x3/cy.svg';
import _cz from 'flag-icons/flags/4x3/cz.svg';
import _de from 'flag-icons/flags/4x3/de.svg';
import _dj from 'flag-icons/flags/4x3/dj.svg';
import _dk from 'flag-icons/flags/4x3/dk.svg';
import _dm from 'flag-icons/flags/4x3/dm.svg';
import _do from 'flag-icons/flags/4x3/do.svg';
import _dz from 'flag-icons/flags/4x3/dz.svg';
import _ec from 'flag-icons/flags/4x3/ec.svg';
import _ee from 'flag-icons/flags/4x3/ee.svg';
import _eg from 'flag-icons/flags/4x3/eg.svg';
import _eh from 'flag-icons/flags/4x3/eh.svg';
import _er from 'flag-icons/flags/4x3/er.svg';
import _es from 'flag-icons/flags/4x3/es.svg';
import _et from 'flag-icons/flags/4x3/et.svg';
import _fi from 'flag-icons/flags/4x3/fi.svg';
import _fj from 'flag-icons/flags/4x3/fj.svg';
import _fk from 'flag-icons/flags/4x3/fk.svg';
import _fm from 'flag-icons/flags/4x3/fm.svg';
import _fo from 'flag-icons/flags/4x3/fo.svg';
import _fr from 'flag-icons/flags/4x3/fr.svg';
import _ga from 'flag-icons/flags/4x3/ga.svg';
import _gb from 'flag-icons/flags/4x3/gb.svg';
import _gd from 'flag-icons/flags/4x3/gd.svg';
import _ge from 'flag-icons/flags/4x3/ge.svg';
import _gf from 'flag-icons/flags/4x3/gf.svg';
import _gg from 'flag-icons/flags/4x3/gg.svg';
import _gh from 'flag-icons/flags/4x3/gh.svg';
import _gi from 'flag-icons/flags/4x3/gi.svg';
import _gl from 'flag-icons/flags/4x3/gl.svg';
import _gm from 'flag-icons/flags/4x3/gm.svg';
import _gn from 'flag-icons/flags/4x3/gn.svg';
import _gp from 'flag-icons/flags/4x3/gp.svg';
import _gq from 'flag-icons/flags/4x3/gq.svg';
import _gr from 'flag-icons/flags/4x3/gr.svg';
import _gs from 'flag-icons/flags/4x3/gs.svg';
import _gt from 'flag-icons/flags/4x3/gt.svg';
import _gu from 'flag-icons/flags/4x3/gu.svg';
import _gw from 'flag-icons/flags/4x3/gw.svg';
import _gy from 'flag-icons/flags/4x3/gy.svg';
import _hk from 'flag-icons/flags/4x3/hk.svg';
import _hm from 'flag-icons/flags/4x3/hm.svg';
import _hn from 'flag-icons/flags/4x3/hn.svg';
import _hr from 'flag-icons/flags/4x3/hr.svg';
import _ht from 'flag-icons/flags/4x3/ht.svg';
import _hu from 'flag-icons/flags/4x3/hu.svg';
import _id from 'flag-icons/flags/4x3/id.svg';
import _ie from 'flag-icons/flags/4x3/ie.svg';
import _il from 'flag-icons/flags/4x3/il.svg';
import _im from 'flag-icons/flags/4x3/im.svg';
import _in from 'flag-icons/flags/4x3/in.svg';
import _io from 'flag-icons/flags/4x3/io.svg';
import _iq from 'flag-icons/flags/4x3/iq.svg';
import _ir from 'flag-icons/flags/4x3/ir.svg';
import _is from 'flag-icons/flags/4x3/is.svg';
import _it from 'flag-icons/flags/4x3/it.svg';
import _je from 'flag-icons/flags/4x3/je.svg';
import _jm from 'flag-icons/flags/4x3/jm.svg';
import _jo from 'flag-icons/flags/4x3/jo.svg';
import _jp from 'flag-icons/flags/4x3/jp.svg';
import _ke from 'flag-icons/flags/4x3/ke.svg';
import _kg from 'flag-icons/flags/4x3/kg.svg';
import _kh from 'flag-icons/flags/4x3/kh.svg';
import _ki from 'flag-icons/flags/4x3/ki.svg';
import _km from 'flag-icons/flags/4x3/km.svg';
import _kn from 'flag-icons/flags/4x3/kn.svg';
import _kp from 'flag-icons/flags/4x3/kp.svg';
import _kr from 'flag-icons/flags/4x3/kr.svg';
import _kw from 'flag-icons/flags/4x3/kw.svg';
import _ky from 'flag-icons/flags/4x3/ky.svg';
import _kz from 'flag-icons/flags/4x3/kz.svg';
import _la from 'flag-icons/flags/4x3/la.svg';
import _lb from 'flag-icons/flags/4x3/lb.svg';
import _lc from 'flag-icons/flags/4x3/lc.svg';
import _li from 'flag-icons/flags/4x3/li.svg';
import _lk from 'flag-icons/flags/4x3/lk.svg';
import _lr from 'flag-icons/flags/4x3/lr.svg';
import _ls from 'flag-icons/flags/4x3/ls.svg';
import _lt from 'flag-icons/flags/4x3/lt.svg';
import _lu from 'flag-icons/flags/4x3/lu.svg';
import _lv from 'flag-icons/flags/4x3/lv.svg';
import _ly from 'flag-icons/flags/4x3/ly.svg';
import _ma from 'flag-icons/flags/4x3/ma.svg';
import _mc from 'flag-icons/flags/4x3/mc.svg';
import _md from 'flag-icons/flags/4x3/md.svg';
import _me from 'flag-icons/flags/4x3/me.svg';
import _mf from 'flag-icons/flags/4x3/mf.svg';
import _mg from 'flag-icons/flags/4x3/mg.svg';
import _mh from 'flag-icons/flags/4x3/mh.svg';
import _mk from 'flag-icons/flags/4x3/mk.svg';
import _ml from 'flag-icons/flags/4x3/ml.svg';
import _mm from 'flag-icons/flags/4x3/mm.svg';
import _mn from 'flag-icons/flags/4x3/mn.svg';
import _mo from 'flag-icons/flags/4x3/mo.svg';
import _mp from 'flag-icons/flags/4x3/mp.svg';
import _mq from 'flag-icons/flags/4x3/mq.svg';
import _mr from 'flag-icons/flags/4x3/mr.svg';
import _ms from 'flag-icons/flags/4x3/ms.svg';
import _mt from 'flag-icons/flags/4x3/mt.svg';
import _mu from 'flag-icons/flags/4x3/mu.svg';
import _mv from 'flag-icons/flags/4x3/mv.svg';
import _mw from 'flag-icons/flags/4x3/mw.svg';
import _mx from 'flag-icons/flags/4x3/mx.svg';
import _my from 'flag-icons/flags/4x3/my.svg';
import _mz from 'flag-icons/flags/4x3/mz.svg';
import _na from 'flag-icons/flags/4x3/na.svg';
import _nc from 'flag-icons/flags/4x3/nc.svg';
import _ne from 'flag-icons/flags/4x3/ne.svg';
import _nf from 'flag-icons/flags/4x3/nf.svg';
import _ng from 'flag-icons/flags/4x3/ng.svg';
import _ni from 'flag-icons/flags/4x3/ni.svg';
import _nl from 'flag-icons/flags/4x3/nl.svg';
import _no from 'flag-icons/flags/4x3/no.svg';
import _np from 'flag-icons/flags/4x3/np.svg';
import _nr from 'flag-icons/flags/4x3/nr.svg';
import _nu from 'flag-icons/flags/4x3/nu.svg';
import _nz from 'flag-icons/flags/4x3/nz.svg';
import _om from 'flag-icons/flags/4x3/om.svg';
import _pa from 'flag-icons/flags/4x3/pa.svg';
import _pe from 'flag-icons/flags/4x3/pe.svg';
import _pf from 'flag-icons/flags/4x3/pf.svg';
import _pg from 'flag-icons/flags/4x3/pg.svg';
import _ph from 'flag-icons/flags/4x3/ph.svg';
import _pk from 'flag-icons/flags/4x3/pk.svg';
import _pl from 'flag-icons/flags/4x3/pl.svg';
import _pm from 'flag-icons/flags/4x3/pm.svg';
import _pn from 'flag-icons/flags/4x3/pn.svg';
import _pr from 'flag-icons/flags/4x3/pr.svg';
import _ps from 'flag-icons/flags/4x3/ps.svg';
import _pt from 'flag-icons/flags/4x3/pt.svg';
import _pw from 'flag-icons/flags/4x3/pw.svg';
import _py from 'flag-icons/flags/4x3/py.svg';
import _qa from 'flag-icons/flags/4x3/qa.svg';
import _re from 'flag-icons/flags/4x3/re.svg';
import _ro from 'flag-icons/flags/4x3/ro.svg';
import _rs from 'flag-icons/flags/4x3/rs.svg';
import _ru from 'flag-icons/flags/4x3/ru.svg';
import _rw from 'flag-icons/flags/4x3/rw.svg';
import _sa from 'flag-icons/flags/4x3/sa.svg';
import _sb from 'flag-icons/flags/4x3/sb.svg';
import _sc from 'flag-icons/flags/4x3/sc.svg';
import _sd from 'flag-icons/flags/4x3/sd.svg';
import _se from 'flag-icons/flags/4x3/se.svg';
import _sg from 'flag-icons/flags/4x3/sg.svg';
import _sh from 'flag-icons/flags/4x3/sh.svg';
import _si from 'flag-icons/flags/4x3/si.svg';
import _sj from 'flag-icons/flags/4x3/sj.svg';
import _sk from 'flag-icons/flags/4x3/sk.svg';
import _sl from 'flag-icons/flags/4x3/sl.svg';
import _sm from 'flag-icons/flags/4x3/sm.svg';
import _sn from 'flag-icons/flags/4x3/sn.svg';
import _so from 'flag-icons/flags/4x3/so.svg';
import _sr from 'flag-icons/flags/4x3/sr.svg';
import _ss from 'flag-icons/flags/4x3/ss.svg';
import _st from 'flag-icons/flags/4x3/st.svg';
import _sv from 'flag-icons/flags/4x3/sv.svg';
import _sx from 'flag-icons/flags/4x3/sx.svg';
import _sy from 'flag-icons/flags/4x3/sy.svg';
import _sz from 'flag-icons/flags/4x3/sz.svg';
import _tc from 'flag-icons/flags/4x3/tc.svg';
import _td from 'flag-icons/flags/4x3/td.svg';
import _tf from 'flag-icons/flags/4x3/tf.svg';
import _tg from 'flag-icons/flags/4x3/tg.svg';
import _th from 'flag-icons/flags/4x3/th.svg';
import _tj from 'flag-icons/flags/4x3/tj.svg';
import _tk from 'flag-icons/flags/4x3/tk.svg';
import _tl from 'flag-icons/flags/4x3/tl.svg';
import _tm from 'flag-icons/flags/4x3/tm.svg';
import _tn from 'flag-icons/flags/4x3/tn.svg';
import _to from 'flag-icons/flags/4x3/to.svg';
import _tr from 'flag-icons/flags/4x3/tr.svg';
import _tt from 'flag-icons/flags/4x3/tt.svg';
import _tv from 'flag-icons/flags/4x3/tv.svg';
import _tw from 'flag-icons/flags/4x3/tw.svg';
import _tz from 'flag-icons/flags/4x3/tz.svg';
import _ua from 'flag-icons/flags/4x3/ua.svg';
import _ug from 'flag-icons/flags/4x3/ug.svg';
import _um from 'flag-icons/flags/4x3/um.svg';
import _us from 'flag-icons/flags/4x3/us.svg';
import _uy from 'flag-icons/flags/4x3/uy.svg';
import _uz from 'flag-icons/flags/4x3/uz.svg';
import _va from 'flag-icons/flags/4x3/va.svg';
import _vc from 'flag-icons/flags/4x3/vc.svg';
import _ve from 'flag-icons/flags/4x3/ve.svg';
import _vg from 'flag-icons/flags/4x3/vg.svg';
import _vi from 'flag-icons/flags/4x3/vi.svg';
import _vn from 'flag-icons/flags/4x3/vn.svg';
import _vu from 'flag-icons/flags/4x3/vu.svg';
import _wf from 'flag-icons/flags/4x3/wf.svg';
import _ws from 'flag-icons/flags/4x3/ws.svg';
import _xk from 'flag-icons/flags/4x3/xk.svg';
import _ye from 'flag-icons/flags/4x3/ye.svg';
import _yt from 'flag-icons/flags/4x3/yt.svg';
import _za from 'flag-icons/flags/4x3/za.svg';
import _zm from 'flag-icons/flags/4x3/zm.svg';
import _zw from 'flag-icons/flags/4x3/zw.svg';
import _fallback from 'i18n/flags/fallback.svg';

/**
 * Country flags by ISO 3166-1 alpha-2 code — the shape Student#nationality is stored in.
 *
 * The images come from `flag-icons` (MIT), which ships one SVG per ISO 3166-1 code and
 * covers all 250 of them, Kosovo's user-assigned XK included. The app's own
 * `i18n/countryFlags` set is deliberately not used here: it is a *language* flag set,
 * built for the support languages, and it silently has no image for 46 countries —
 * Angola, Palestine and Western Sahara among them.
 *
 * Distinct from localeFlags for the same reason: that map is keyed by *language* code, and
 * a language is not a country, so the two must not share a map even where they happen to
 * pick the same image.
 *
 * The same set and the same mapping ship in the Rails app under
 * app/assets/images/flags/countries, generated from this same package version, so a
 * student's flag does not change between the two.
 *
 * The map is static rather than lazy because Vite emits every .svg as its own file — it
 * refuses to base64-inline SVG at any assetsInlineLimit — so what lands in the bundle is
 * 250 short URL strings, and the browser fetches only the flags it draws.
 * Same shape as localeFlags beside it.
 */
const countryFlags = new Map<string, string>([
  ['AD', _ad],
  ['AE', _ae],
  ['AF', _af],
  ['AG', _ag],
  ['AI', _ai],
  ['AL', _al],
  ['AM', _am],
  ['AO', _ao],
  ['AQ', _aq],
  ['AR', _ar],
  ['AS', _as],
  ['AT', _at],
  ['AU', _au],
  ['AW', _aw],
  ['AX', _ax],
  ['AZ', _az],
  ['BA', _ba],
  ['BB', _bb],
  ['BD', _bd],
  ['BE', _be],
  ['BF', _bf],
  ['BG', _bg],
  ['BH', _bh],
  ['BI', _bi],
  ['BJ', _bj],
  ['BL', _bl],
  ['BM', _bm],
  ['BN', _bn],
  ['BO', _bo],
  ['BQ', _bq],
  ['BR', _br],
  ['BS', _bs],
  ['BT', _bt],
  ['BV', _bv],
  ['BW', _bw],
  ['BY', _by],
  ['BZ', _bz],
  ['CA', _ca],
  ['CC', _cc],
  ['CD', _cd],
  ['CF', _cf],
  ['CG', _cg],
  ['CH', _ch],
  ['CI', _ci],
  ['CK', _ck],
  ['CL', _cl],
  ['CM', _cm],
  ['CN', _cn],
  ['CO', _co],
  ['CR', _cr],
  ['CU', _cu],
  ['CV', _cv],
  ['CW', _cw],
  ['CX', _cx],
  ['CY', _cy],
  ['CZ', _cz],
  ['DE', _de],
  ['DJ', _dj],
  ['DK', _dk],
  ['DM', _dm],
  ['DO', _do],
  ['DZ', _dz],
  ['EC', _ec],
  ['EE', _ee],
  ['EG', _eg],
  ['EH', _eh],
  ['ER', _er],
  ['ES', _es],
  ['ET', _et],
  ['FI', _fi],
  ['FJ', _fj],
  ['FK', _fk],
  ['FM', _fm],
  ['FO', _fo],
  ['FR', _fr],
  ['GA', _ga],
  ['GB', _gb],
  ['GD', _gd],
  ['GE', _ge],
  ['GF', _gf],
  ['GG', _gg],
  ['GH', _gh],
  ['GI', _gi],
  ['GL', _gl],
  ['GM', _gm],
  ['GN', _gn],
  ['GP', _gp],
  ['GQ', _gq],
  ['GR', _gr],
  ['GS', _gs],
  ['GT', _gt],
  ['GU', _gu],
  ['GW', _gw],
  ['GY', _gy],
  ['HK', _hk],
  ['HM', _hm],
  ['HN', _hn],
  ['HR', _hr],
  ['HT', _ht],
  ['HU', _hu],
  ['ID', _id],
  ['IE', _ie],
  ['IL', _il],
  ['IM', _im],
  ['IN', _in],
  ['IO', _io],
  ['IQ', _iq],
  ['IR', _ir],
  ['IS', _is],
  ['IT', _it],
  ['JE', _je],
  ['JM', _jm],
  ['JO', _jo],
  ['JP', _jp],
  ['KE', _ke],
  ['KG', _kg],
  ['KH', _kh],
  ['KI', _ki],
  ['KM', _km],
  ['KN', _kn],
  ['KP', _kp],
  ['KR', _kr],
  ['KW', _kw],
  ['KY', _ky],
  ['KZ', _kz],
  ['LA', _la],
  ['LB', _lb],
  ['LC', _lc],
  ['LI', _li],
  ['LK', _lk],
  ['LR', _lr],
  ['LS', _ls],
  ['LT', _lt],
  ['LU', _lu],
  ['LV', _lv],
  ['LY', _ly],
  ['MA', _ma],
  ['MC', _mc],
  ['MD', _md],
  ['ME', _me],
  ['MF', _mf],
  ['MG', _mg],
  ['MH', _mh],
  ['MK', _mk],
  ['ML', _ml],
  ['MM', _mm],
  ['MN', _mn],
  ['MO', _mo],
  ['MP', _mp],
  ['MQ', _mq],
  ['MR', _mr],
  ['MS', _ms],
  ['MT', _mt],
  ['MU', _mu],
  ['MV', _mv],
  ['MW', _mw],
  ['MX', _mx],
  ['MY', _my],
  ['MZ', _mz],
  ['NA', _na],
  ['NC', _nc],
  ['NE', _ne],
  ['NF', _nf],
  ['NG', _ng],
  ['NI', _ni],
  ['NL', _nl],
  ['NO', _no],
  ['NP', _np],
  ['NR', _nr],
  ['NU', _nu],
  ['NZ', _nz],
  ['OM', _om],
  ['PA', _pa],
  ['PE', _pe],
  ['PF', _pf],
  ['PG', _pg],
  ['PH', _ph],
  ['PK', _pk],
  ['PL', _pl],
  ['PM', _pm],
  ['PN', _pn],
  ['PR', _pr],
  ['PS', _ps],
  ['PT', _pt],
  ['PW', _pw],
  ['PY', _py],
  ['QA', _qa],
  ['RE', _re],
  ['RO', _ro],
  ['RS', _rs],
  ['RU', _ru],
  ['RW', _rw],
  ['SA', _sa],
  ['SB', _sb],
  ['SC', _sc],
  ['SD', _sd],
  ['SE', _se],
  ['SG', _sg],
  ['SH', _sh],
  ['SI', _si],
  ['SJ', _sj],
  ['SK', _sk],
  ['SL', _sl],
  ['SM', _sm],
  ['SN', _sn],
  ['SO', _so],
  ['SR', _sr],
  ['SS', _ss],
  ['ST', _st],
  ['SV', _sv],
  ['SX', _sx],
  ['SY', _sy],
  ['SZ', _sz],
  ['TC', _tc],
  ['TD', _td],
  ['TF', _tf],
  ['TG', _tg],
  ['TH', _th],
  ['TJ', _tj],
  ['TK', _tk],
  ['TL', _tl],
  ['TM', _tm],
  ['TN', _tn],
  ['TO', _to],
  ['TR', _tr],
  ['TT', _tt],
  ['TV', _tv],
  ['TW', _tw],
  ['TZ', _tz],
  ['UA', _ua],
  ['UG', _ug],
  ['UM', _um],
  ['US', _us],
  ['UY', _uy],
  ['UZ', _uz],
  ['VA', _va],
  ['VC', _vc],
  ['VE', _ve],
  ['VG', _vg],
  ['VI', _vi],
  ['VN', _vn],
  ['VU', _vu],
  ['WF', _wf],
  ['WS', _ws],
  ['XK', _xk],
  ['YE', _ye],
  ['YT', _yt],
  ['ZA', _za],
  ['ZM', _zm],
  ['ZW', _zw]
]);

/** Only reachable for a value that is not an ISO 3166-1 country at all. */
export const COUNTRY_FLAG_FALLBACK = _fallback;

export function getCountryFlag(alpha2: string | null | undefined): string {
  if (!alpha2) return COUNTRY_FLAG_FALLBACK;

  return countryFlags.get(alpha2.toUpperCase()) ?? COUNTRY_FLAG_FALLBACK;
}

export default countryFlags;
